import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ChatProvider } from './contexts/ChatContext';
import { Login } from './pages/Login';
import { Chat } from './components/Chat';
import { Pricing } from './pages/Pricing';
import ApiDashboard from './pages/ApiDashboard';
import ReactGA from 'react-ga4';
import { initClarity } from './lib/clarity';

// Initialize GA4 with your measurement ID
ReactGA.initialize('G-EC67FMKJTJ'); // Replace with your GA4 measurement ID

// Analytics wrapper component
const AnalyticsWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Initialize Clarity
    initClarity();
    
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return <>{children}</>;
};

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  return user ? <>{children}</> : <Navigate to="/" />;
};

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  return !user ? <>{children}</> : <Navigate to="/chat" />;
};

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  return user ? <>{children}</> : <Navigate to="/" />;
};

function App() {
  return (
    <AuthProvider>
      <ChatProvider>
        <Router>
          <AnalyticsWrapper>
            <Routes>
              <Route path="/" element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              } />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/chat" element={
                <PrivateRoute>
                  <Chat />
                </PrivateRoute>
              } />
              <Route 
                path="/dashboard/api" 
                element={
                  <ProtectedRoute>
                    <ApiDashboard />
                  </ProtectedRoute>
                } 
              />
            </Routes>
          </AnalyticsWrapper>
        </Router>
      </ChatProvider>
    </AuthProvider>
  );
}

export default App; 